import { render, staticRenderFns } from "./SignAuthorizeBtn.vue?vue&type=template&id=e47d8352&scoped=true&"
import script from "./SignAuthorizeBtn.vue?vue&type=script&lang=js&"
export * from "./SignAuthorizeBtn.vue?vue&type=script&lang=js&"
import style0 from "./SignAuthorizeBtn.vue?vue&type=style&index=0&id=e47d8352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47d8352",
  null
  
)

export default component.exports